// @ts-nocheck
import { HeaderIsFullOpacityParameter } from "@store/Framework/Store/Bunzl/Components/Header/HeaderTypes";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type Parameter = HeaderIsFullOpacityParameter;
type HandlerType = Handler<Parameter>;

export const dispatchFullOpacity: HandlerType = props => {
    props.dispatch({
        type: "Store/Components/Header/SetFullOpacity",
        parameter: props.parameter,
    });
};

export const chain = [dispatchFullOpacity];

const setHeaderFullOpacity = createHandlerChainRunner(chain, "SetHeaderFullOpacity");
export default setHeaderFullOpacity;
